<script setup lang="ts">
import { useModel } from './../model/model.ts'
import './assets/style.scss'
import { useAuth } from '@/entities/Auth'

const model = useModel()
const { isPermissions } = useAuth()
</script>

<template>
  <VBtn
    color="white"
    class="w-full schedule-create__button"
    @click="model.openForm = true"
    :class="{ disabled: !isPermissions(['SСHEDULE_CREATE']) }"
  >
    {{ $t('itf.add') }}
  </VBtn>
</template>
